import { ThemeProvider, createTheme, Box } from "@mui/material";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch-dom";
import { Outlet, useLocation } from "react-router-dom";

import { useCheckMaintenanceBannerQuery } from "api/app/app.api";
import LoadingSpinner from "components/UI/LoadingSpinner/LoadingSpinner";
import { useAuth } from "hooks/useAuth";

import AppLogout from "./components/AppLogout";
import DailyDeployBanner from "./components/DailyDeployBanner";
import DevBanner from "./components/DevBanner";
import Footer from "./components/Footer/Footer.screen";
import NavigationBar from "./components/NavigationBar/NavigationBar";
import ScrollToTop from "./components/ScrollToTop";

import "./App.css";

const searchClient = algoliasearch(
  "31P4SHL05P",
  "3e9d823d46542e1e805f9f12cce0ade1",
);

const defaultReactTheme = createTheme({
  palette: {
    primary: {
      main: "#0b2241",
    },
    secondary: {
      main: "#6c757d",
    },
    success: {
      main: "#198754",
    },
    info: {
      main: "#0dcaf0",
    },
    warning: {
      main: "#f8c95a",
    },
    // TODO: look more into this https://mui.com/material-ui/customization/theming/#custom-variables
    // @ts-ignore
    danger: {
      main: "#dc3545",
    },
    // this is probably what we want instead of danger
    error: {
      main: "#dc3545",
    },
    light: {
      main: "#f8f9fa",
    },
    dark: {
      main: "#212529",
    },
  },
  typography: {
    fontFamily: "Helvetica, sans-serif",
  },
});

const BANNER_HEIGHT = 56;

function App() {
  const { oldAuthToken } = useAuth();

  const location = useLocation();
  const onLoginScreen = location.pathname.includes("login");
  const { data: bannerEnabled = false } = useCheckMaintenanceBannerQuery();
  const shouldShowBanner = bannerEnabled && !onLoginScreen;
  let isDev =
    process.env.REACT_APP_REACT_ENDPOINT === "https://dev.niap-ccevs.org/";

  return (
    <div className={oldAuthToken ? "border border-5 border-danger" : ""}>
      <InstantSearch searchClient={searchClient} indexName="test_HBD">
        <ThemeProvider theme={defaultReactTheme}>
          <LoadingSpinner />
          <Box sx={{ mt: `${isDev ? BANNER_HEIGHT : 0}px` }}>
            <AppLogout>
              {shouldShowBanner && <DailyDeployBanner />}
              {isDev && <DevBanner bannerHeight={BANNER_HEIGHT} />}

              <ScrollToTop />

              <div className="header">
                <NavigationBar />
              </div>

              <Outlet />

              <Footer />
            </AppLogout>
          </Box>
        </ThemeProvider>
      </InstantSearch>
    </div>
  );
}

export default App;
